import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";
import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { vendorProductsSlice } from "@/services/api/cresivoxServer";


import { REDUCER_NAME, iVendorProductsState} from './Types';
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);



export const getVendorProductsList = createAsyncThunk<
  iGenericResponse<any | null> | null,
void,
  {
	  rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getVendorProductsList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async ({ status }, {rejectWithValue}) => {
	  try {
		  const response = await vendorProductsSlice.getVendorProductsList(status);
		  if (response) {
			  const {httpStatusCode, data, message} = response;

			  switch (httpStatusCode) {
				  case httpStatusCodes.SUCCESS_OK: {
					  if (data && data.data) {
						  return {
							data:{
							  httpStatusCode,
							  data: data.data,
							  message,
							}
						  };
					  } else {
						  return rejectWithValue({
							  httpStatusCode,
							  message,
						  });
					  }
				  }
				  default: {
					  return rejectWithValue({
						  httpStatusCode,
						  message,
					  });
				  }
			  }
		  } else {
			  return rejectWithValue({
				  message: "No response received",
			  });
		  }
	  } catch (error) {
		  return rejectWithValue({
			  message: "Something went wrong",
		  });
	  }
  },
);


export const statusUpdateVendorProducts = createAsyncThunk<
// @ts-expect-error
  iGenericResponse<iProductReportResponse> | null,
  { productId: string; status: string }, 
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("statusUpdateVendorProducts"),
// @ts-expect-error
  async ({ productId, status }, { rejectWithValue }) => {
    try {
      // 👇 pass status into service call
      const response = await vendorProductsSlice.statusUpdateVendorProducts(productId, status);

      if (response) {
        const { httpStatusCode, data, message } = response;
        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                data: {
                  orders: data.data,
                  message,
                },
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message: "Product data is missing",
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received from the server",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong while updating product status",
      });
    }
  }
);








